<template>
	<div class="wrapper">
		<ShareHeader :openTarget="'openclass/detail?id=' + courseid" />
		<div id="topVideoWrapper" class="topVideoWrapper" ref="topVideoWrapper">
			<VideoPlayer :options="videoOptions"/>
		</div>
		<div class="topFollowButtonWrapper">
			<div class="followButton">
				打开APP查看更多
				<WxOpenTag :extinfo="'openclass/detail?id=' + courseid"/>
			</div>
		</div>
		<div class="contentSection">
			<div class="mainTitle">{{courseData.title}}</div>
			<div class="describe" v-html="courseData.about"></div>
			<div class="statisticSection">
				<div class="statisticItem">
					<div class="icon"><img src="../../../assets/image/course/comment.png"></div>
					<span class="statisticNum">{{courseData.postnum}}</span>
				</div>
				<div class="statisticItem">
					<div class="icon"><img src="../../../assets/image/course/favor.png"></div>
					<span class="statisticNum">{{courseData.likenum}}</span>
				</div>
			</div>
		</div>
		<div class="otherHotCourse">
			<div class="title">其他热门</div>
			<div class="courseItemWrapper">
				<div class="courseItem" v-for="course of recommendCourseList" :key="course.courseid">
					<div class="coverWrapper">
						<img class="coverImg" :src="course.pic" />
					</div>
					<div class="courseTitle">{{course.title}}</div>
				</div>
			</div>
		</div>
		<div class="commentSection">
			<CommentMod :comments="commentList" :jumpTarget="'openclass/detail?id=' + courseid" />
			<!-- <div class="commentTitleWrapper">
				<div class="title">全部评论</div>
			</div>
			<ElaborateCourseCommentSection v-for="comment of commentList" :sectionData="comment" :key="comment.id + comment.createdtime" /> -->
		</div>
		<div class="followButton">
			打开APP查看更多
			<WxOpenTag :extinfo="'openclass/detail?id=' + courseid"/>
		</div>
	</div>
</template>

<script>
import utils from '@/utils/utils'
import WxShare from '@/utils/wxshare'
import ShareHeader from '@/components/HeadModule'
import WxOpenTag from '@/components/WxOpenTag'
import VideoPlayer from '@/components/VideoPlayer'
import CommentMod from '../CommentMod'
/*import ElaborateCourseCommentSection from '../ElaborateCourseCommentSection'*/
export default {
	data(){
		return {
			courseid: this.$route.query.courseid,
			courseData: {},
			recommendCourseList: [],
			commentList: [],
			videoOptions: {}
		}
	},
	mounted(){
		this.init()
	},
	methods: {
		init(){
			this.getCourseInfo()
			this.getCommentList()
		},
		getCourseInfo(){
			this.$http.get('/edu/openCourseDetail', {
				params: {
					course_id: this.courseid
				}
			}).then(res => {
				if(res.code >= 0){
					this.courseData = res.data
					this.recommendCourseList = res.data.more
					this.videoOptions = {
						poster: res.data.pic,
						sources: [{
							src: utils.au(res.data.play_url),
							type: 'video/mp4'
						}]
					}
					new WxShare().share({
						title: res.data.title,
						desc: utils.trimHtmlTag(res.data.about),
						link: window.location.href,
						imgUrl: res.data.pic
					})
				}
			})
		},
		getCommentList(){
			this.$http.get('/edu/comment', {
				params: {
					course_id: this.courseid,
					type: 0,
					start: 0,
					limit: 4
				}
			}).then(res => {
				if(res.code >= 0){
					this.commentList = res.data
				}
			})
		},
	},
	components: {
		ShareHeader: ShareHeader,
		VideoPlayer: VideoPlayer,
		CommentMod: CommentMod,
		WxOpenTag: WxOpenTag,
		/*ElaborateCourseCommentSection: ElaborateCourseCommentSection*/
	}
}
</script>

<style scoped>
.wrapper{
	background-color: #f7f8f8;
}
.mainTitle{
	font-size: 20px;
	font-weight: 600;
	color: #1d2023;
	padding: 0 0 8px 0;
	margin: 0;
}
.title{
	font-size: 18px;
	font-weight: 600;
	color: #1d2023;
	padding: 0;
	margin: 0;
}
.icon{
	display: inline-block;
	width: 20px;
	margin-right: 2px;
	vertical-align: middle;
	flex-shrink: 0;
}
.icon > img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.coverImg{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.line{
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.topVideoWrapper{
	/*min-height: 190px;*/
	/*padding-top: 190px;
	padding-top: calc(100% / 1.44 - 50);
	background: #d8d8d8 no-repeat;
	background-size: cover;
	background-position: center;*/
}
.topFollowButtonWrapper{
	overflow: hidden;
	background-color: #fff;
}
.followButton{
	position: relative;
	margin: 15px;
	padding: 8px;
	font-size: 16px;
	color: #fff;
	text-align: center;
	border-radius: 5px;
	overflow: hidden;
	background-color: #e50120;
}
.contentSection{
	padding: 0 15px 10px 15px;
	font-size: 14px;
	color: #606972;
	background-color: #fff;
}
.describe img{
	max-width: 100%;
	height: auto;
}
.statisticSection{
	display: flex;
	flex-direction: row-reverse;
	margin-top: 15px;
}
.statisticItem{
	display: flex;
	align-items: top;
	margin-left: 5px;
}
.statisticNum{
	font-size: 10px;
}

.otherHotCourse{
	margin-top: 10px;
	padding: 15px;
	background-color: #fff;
}
.courseItemWrapper{
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	margin-top: 8px;
}
.courseItem{
	width: 48%;
	margin: 6px 0;
}
.coverWrapper{
	width: 100%;
	height: 103px;
	border-radius: 5px;
	overflow: hidden;
	background-color: #eee;
}
.courseTitle{
	height: 40px;
	margin-top: 5px;
	font-size: 14px;
	line-height: 20px;
	color: #1d2023;
	overflow: hidden;
	text-overflow: ellipsis;
	line-clamp: 2;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
}
.commentSection{
	margin-top: 10px;
	background-color: #fff;
}
.commentTitleWrapper{
	padding: 15px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.commentSection .itemWrapper:last-child{
	border-bottom: none;
}
</style>